/**
 * ISSUE-0187 — load the browser session without the axios 401 interceptor.
 *
 * A logged-out GET /auth/me is an expected miss. It must not start the
 * interceptor's refresh-and-redirect path, which uses the path at failure time
 * and can send a just-completed login back to /login.
 *
 * An expired access cookie is recovered here with skipAuthRefresh so a valid
 * refresh cookie still restores the session, and a newer sign-in (epoch change)
 * is never overwritten or rotated.
 */

export async function probeSession(apiClient, stillCurrent) {
  const readMe = () => apiClient.get('/auth/me', { skipAuthRefresh: true });

  try {
    const { data } = await readMe();
    if (!stillCurrent()) return { status: 'stale', user: data };
    return { status: 'user', user: data };
  } catch (err) {
    if (!stillCurrent()) return { status: 'stale' };
    if (err?.response?.status !== 401) return { status: 'anonymous' };
    try {
      await apiClient.post('/auth/refresh', null, { skipAuthRefresh: true });
    } catch {
      if (!stillCurrent()) return { status: 'stale' };
      return { status: 'anonymous' };
    }
    if (!stillCurrent()) return { status: 'stale' };
    try {
      const { data } = await readMe();
      if (!stillCurrent()) return { status: 'stale', user: data };
      return { status: 'user', user: data };
    } catch {
      if (!stillCurrent()) return { status: 'stale' };
      return { status: 'anonymous' };
    }
  }
}
